<template>
  <div>

    <div v-for="(option, key) in options" :key="key" class="switch-wrapper">
      <div class="question">{{option.question}}</div>
      <div class="switch">
        <input 
          type="checkbox"
          :id="option.id"
          :value="option"
          v-model="selectedValues"
          class="switch-input"    
        />
        <label :for="option.id" class="switch-label"></label>
      </div>
    </div>
  </div>
</template>



<script>
export default {
  name: "SwitchButtonGroup",
  props: {
    options: {
      required: true
    },
    value: {
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      selectedValues: []
    }
  },
  watch: {
    selectedValues(newVal) {
      this.$emit("input", newVal)
    }
  },
  created() {
    if (this.value.length > 0) this.selectedValues = this.value
  }
}
</script>

<style scoped>
.switch-wrapper {
  display: grid;
  grid-template-columns: 2fr 1fr;
  margin: 2em 0;
}

.question {
  font-size: 1.5rem;
  align-self: center;
}

.switch {
  position: relative;
  display: block;
  width: 48px;
  align-self: center;
  justify-self: end;
  margin-right: 48px;
}

.switch:before {
  content: "Ja";
  position: absolute;
  width: 20px;
  display: block;
  top: 14px;
  left: 19px;
  font-size: 0.8rem;
  font-weight: bold;
  color: #444444;
}

.switch::after {
  content: "Nej";
  position: absolute;
  width: 20px;
  display: block;
  top: 14px;
  right: -26px;
  font-size: 0.8rem;
  font-weight: bold;
  z-index: 0;
  color: #444444;
}


.switch-input {
  display: none;
}

.switch-label {
  display: block;
  width: 88px;
  height: 43px;
  text-indent: -150%;
  clip: rect(0 0 0 0);
  user-select: none;
  margin-bottom: 0;
  box-sizing: content-box;
}
.switch-label::before,
.switch-label::after {
  content: "";
  display: block;
  position: absolute;
  cursor: pointer;
  z-index: 1;
}
.switch-label::before {
  width: 88px;
  height: 100%;
  background-color: transparent;
  border: 2px solid #444444;
  border-radius: 0.4rem;
  -webkit-transition: background-color 0.25s ease;
  transition: background-color 0.25s ease;
  box-shadow: 0px 1px 3px #76b4bf;
}
.switch-label::after {
    content: "";
    color: #808c94;
    top: 8px;
    right: -36px;
    width: 18px;
    height: 13px;
    border-radius: 0.25rem;
    background-color: #607d8b40;
    transition: left 0.25s ease;
    text-align: right;
    font-size: 0.8rem;
    padding: 6px 9px 12px 12px;
    font-weight: bold;
}

.switch-input:checked + .switch-label::after {
  content: "Ja";
  color: white;
  background-color: #2c3e50;
  right: 3px;
  padding: 6px 13px 12px 7px;
}

@media (max-width: 767px) {
  .question {
    font-size: 1em;
  }
  .switch-wrapper {
    margin: 1em 0;
  }
}

</style>
